import { render, staticRenderFns } from "./DSInlineAlert.vue?vue&type=template&id=4bddba12&scoped=true&"
import script from "./DSInlineAlert.vue?vue&type=script&lang=ts&"
export * from "./DSInlineAlert.vue?vue&type=script&lang=ts&"
import style0 from "./DSInlineAlert.vue?vue&type=style&index=0&id=4bddba12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bddba12",
  null
  
)

export default component.exports